import ContactSection from '../components/section/ContactSection';
import BusinessInfo from 'src/components/BusinessInfo';

const BusinessPage = ({ natureOfBusOptions }) => {
  return (
    <>
      <BusinessInfo natureOfBusOptions={natureOfBusOptions} />
      <ContactSection />
    </>
  );
};

export default BusinessPage;
